import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface MenuProps {
  selected?: string | number;
  options: {
    title: string;
    value: string | number;
  }[];
  className?: Partial<{
    wrapper: string;
    item: string;
  }>;
  onChange: (value: string | number) => void;
}

const DropdownMenu = forwardRef(({ selected, options, onChange, className }: MenuProps, ref: any) => {
  return (
    <div ref={ref} className={twMerge('max-h-[300px] overflow-y-auto px-[8px] py-[4px] bg-white dark:bg-quinary rounded-[12px]', className?.wrapper)}>
      {options.map(({ title, value }) => (
        <div
          key={value}
          className={twMerge('flex items-center text-dark hover:text-black dark:hover:text-black hover:bg-gray-0 dark:hover:bg-gray-0 cursor-pointer h-[32px] border-b-[1px] border-b-gray-0 dark:bg-quinary dark:text-white', selected === value && '!text-primary dark:!text-secondary', className?.item)}
          onClick={() => onChange(value)}
        >
          {title}
        </div>
      ))}
    </div>
  )
})


export default DropdownMenu;